import * as yup from 'yup'

const schema = yup.object().shape({
  companyId: yup.string().required(),
  departmentsMultiSelect: yup.string().required(),
})

export default schema
